/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Save_TipInputs */

const en_pc_tut_save_tip = /** @type {(inputs: Pc_Tut_Save_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the interface language in Preferences: ⌘, on a Mac, Ctrl+, elsewhere.`)
};

const zh_pc_tut_save_tip = /** @type {(inputs: Pc_Tut_Save_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在偏好设置中修改界面语言：Mac 按 ⌘,，其他系统按 Ctrl+,。`)
};

/**
* | output |
* | --- |
* | "Change the interface language in Preferences: ⌘, on a Mac, Ctrl+, elsewhere." |
*
* @param {Pc_Tut_Save_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_save_tip = /** @type {((inputs?: Pc_Tut_Save_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Save_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_save_tip(inputs)
	return zh_pc_tut_save_tip(inputs)
});
export { pc_tut_save_tip as "pc.tut.save.tip" }